import { render, staticRenderFns } from "./RequestTokenCameraDialog.vue?vue&type=template&id=2c2d0e0a&scoped=true"
import script from "./RequestTokenCameraDialog.vue?vue&type=script&lang=js"
export * from "./RequestTokenCameraDialog.vue?vue&type=script&lang=js"
import style0 from "./RequestTokenCameraDialog.vue?vue&type=style&index=0&id=2c2d0e0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2d0e0a",
  null
  
)

export default component.exports